export const LOCATION_FILTER_TYPES = [
    'COUNTRY',
    'REGION',
    'PROVINCE',
    'MUNICIPALITY',
    'CITY',
    'DISTRICT',
    'LOCALITY',
    'POSTAL_CODE',
    'POINT',
];
export const LOCATION_SUGGESTION_TYPES = [...LOCATION_FILTER_TYPES, 'PLACE'];
